import {CachingCollection} from "../../../collections/_BaseCollection";

export class BaseControlCollection<TModel extends Backbone.Model> extends CachingCollection<TModel> {
    appUrlRoot = 'controls';
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/controls/collections/_BaseControlCollection.ts